import { Controller } from "@hotwired/stimulus"

// Opens/closes the per-member "internal team roles" editor in a native <dialog>.
// Closes on backdrop click and (natively) on Escape; restores body scroll.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  // Fired by the dialog's native `close` event (Escape, close(), or form submit).
  onClose() {
    document.body.style.overflow = ""
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
